module.exports = __webpack_public_path__ + "img/ic_32_workout_intensity-high.87316e6d.svg";